export const BUILDING_TYPE = {
  FRONT_OR_SINGLE_HOUSE: {label: "Vorderhaus/Einzelnes Haus", value: "FRONT_OR_SINGLE_HOUSE"},
  REAR_HOUSE: {label: "Hinterhaus", value: "REAR_HOUSE"},
  SIDE_WING: {label: "Seitenflügel", value: "SIDE_WING"},
  COACH_HOUSE: {label: "Remise", value: "COACH_HOUSE"},
  ANNEX: {label: "Anbau", value: "ANNEX"},
  AUXILIARY_BUILDING: {label: "Zusatzgebäude", value: "AUXILIARY_BUILDING"},
}